import { form2fhir } from '../Date/Format/index.js'

import { transform } from './mapper.js'

const CodeUrl = 'http://narus.com/fhir/utilizationexpense'

const ExtensionType = {
  url: 'http://narus.com/fhir/utilizationexpense-type'
}

const ExtensionCategory = {
  url: 'http://narus.com/fhir/utilizationexpense-category'
}

const ExtensionHardSoft = {
  url: 'http://narus.com/fhir/utilizationexpense-hardsoft'
}

const ExtensionStartDate = {
  url: 'http://narus.com/fhir/utilizationexpense-startdate'
}

const ExtensionStopDate = {
  url: 'http://narus.com/fhir/utilizationexpense-stopdate'
}

const ExtensionAmount = {
  url: 'http://narus.com/fhir/utilizationexpense-amount'
}

const ExtensionAmountType = {
  url: 'http://narus.com/fhir/utilizationexpense-amounttype'
}

const ExtensionVerified = {
  url: 'http://narus.com/fhir/utilizationexpense-verified'
}

const ExtensionComments = {
  url: 'http://narus.com/fhir/utilizationexpense-comments'
}

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Basic'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'extension', ExtensionType, 'valueString' ],
    form: [ 'type' ]
  },
  {
    fhir: [ 'extension', ExtensionCategory, 'valueString' ],
    form: [ 'category' ]
  },
  {
    fhir: [ 'extension', ExtensionHardSoft, 'valueString' ],
    form: [ 'hardSoft' ]
  },
  {
    fhir: [ 'extension', ExtensionStartDate, 'valueDate' ],
    form: [ 'startDate' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'extension', ExtensionStopDate, 'valueDate' ],
    form: [ 'stopDate' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'extension', ExtensionAmount, 'valueString' ],
    form: [ 'amount' ]
  },
  {
    fhir: [ 'extension', ExtensionAmountType, 'valueString' ],
    form: [ 'amountType' ]
  },
  {
    fhir: [ 'extension', ExtensionVerified, 'valueBoolean' ],
    form: [ 'verified' ]
  },
  {
    fhir: [ 'extension', ExtensionComments, 'valueString' ],
    form: [ 'comments' ]
  }
]

export function toFHIR (data, patientId) {
  const res = transform(data, mapping, [ 'form', 'fhir' ])
  const ptRef = { reference: `Patient/${patientId}` }
  res.subject = ptRef
  res.author = ptRef
  res.code = {
    coding: [
      {
        system: CodeUrl,
        code: 'utilizationexpense',
        display: 'Utilization & Expense'
      }
    ]
  }
  return res
}

export function fromFHIR (data) {
  return transform(data, mapping, [ 'fhir', 'form' ])
}
